<template>
  <div class="dim-layer" @keydown="keymap">
    <div class="set-box">
      <div disabled class="inner-box">
        <div class="inp-wrapper">
          <div class="header">
            <GrmBackBtn class="back-btn" @click="back" />
            <p class="inp-title">{{ $t("guest.name") }}</p>
          </div>
          <GrmInput
            ref="nickname"
            :minlength="2"
            :maxlength="25"
            :placeholder="nicknamePlaceholder"
            :checkList="nicknameCheckList"
            v-model="nickname"
          />
        </div>
        <GrmBtn
          class="btn-login w-full"
          :disabled="disabledGuestLogin"
          @click="handleGuestLogin"
        >{{ $t("guest.join") }}</GrmBtn>
      </div>
    </div>
  </div>
</template>

<script>
import GrmBackBtn from "@/components/Common/button/GrmBackBtn";
import GrmInput from "@/components/Common/input/GrmInput";
import GrmBtn from "@/components/Common/button/GrmBtn";

export default {
  name: 'RoomJoinGuest',
  components: {
    GrmBtn,
    GrmInput,
    GrmBackBtn,
  },
  data (){
    return {
      nickname: "",
      nicknamePlaceholder: 'Guest' + parseInt(Math.random() * 100),
      nicknameCheckList: [
        { checked: false, text: this.$t('guest.nickNameRole') },
      ]
    }
  },
  created() {
    this.nickname = this.nicknamePlaceholder;
  },
  mounted() {
    this.focusNickname();
  },
  computed: {
    disabledGuestLogin() {
      return this.nicknameCheckList.some((item) => !item.checked);
    },
  },
  watch: {
    nickname: {
      handler() {
        this.nicknameCheckList[0].checked = this.nickname.length >= 2 && this.nickname.length <= 25;
      },
      deep: true,
    },
  },
  methods: {
    keymap(e) {
      switch (e.keyCode) {
        case 13:
          this.handleGuestLogin();
          break
        case 27:
          this.back();
          break
      }
    },
    handleGuestLogin(){
      if (this.nickname === '') {
        this.nickname = this.nicknamePlaceholder
      }

      if (this.disabledGuestLogin) {
        return;
      }

      this.$parent.joinGuest(this.nickname);
    },
    back() {
      this.$alert({
        text: this.$t('guest.back'),
        ok: () => {
          window.history.back();
        },
        finally: () => {
          this.focusNickname();
        }
      });
    },
    focusNickname() {
      this.$refs.nickname.$refs.input.focus();
    },
  }
}
</script>

<style lang="scss" scoped>
.dim-layer {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  &.inRoom {
    background-color: rgba(0, 0, 0, 0.5);
  }
}
.set-box {
  width: 400px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 24px;
  position: relative;
}
.inner-box {}
.inp-wrapper {
  margin-top: 20px;
  &:first-child{
    margin-top: 0
  }
}
.header {
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.inp-title {
  font-weight: 700;
}
.btn-login {
  margin-top: 16px;
}
.back-btn {
  position: absolute;
  left: 0;
}

[grm-device-mobile] {
  .set-box {
    width: 100%;
    height: 100%;
    border-radius: 0;
    padding: 0 24px 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .inner-box {
    width: 100%;
  }
  .btn-login {
    height: 52px !important;
    border-radius: 0;
    font-size: 14px;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    &::v-deep {
      .v-button {
        border-radius: 0;
      }
    }
  }
  .back-btn {
    position: fixed;
    top: 24px;
    left: 24px;
  }
}
</style>